import React from "react"
import PropTypes from "prop-types"
import isEmpty from "lodash/isEmpty"
import { Button, LoaderIcon, ErrorMessageSection } from "components"

const SubmitSection = ({
  errorMessages = [],
  error,
  submitting,
  buttonText,
  styleNameButton,
  styleNameLoader = "dark",
  gtmEvents = [],
  onSubmit = () => {},
  canSubmit
}) => {
  return (
    <div>
      <div style={{ margin: "1em 0" }}>
        {error && <ErrorMessageSection error={error} />}
        {errorMessages &&
          Array.isArray(errorMessages) &&
          errorMessages.map((errorItem, index) => {
            return !isEmpty(errorItem) && <ErrorMessageSection key={index} error={errorItem} />
          })}
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center"
        }}>
        {submitting ? (
          <div style={{ margin: "1em auto" }}>
            <LoaderIcon styleName={styleNameLoader === "dark" ? "light" : "dark"} />
          </div>
        ) : (
          <Button
            label={buttonText}
            styleName={styleNameButton || "black"}
            display="block"
            fullWidth
            onClick={onSubmit}
            disabledStyle={!canSubmit}
            gtmEvents={canSubmit ? gtmEvents : undefined} />
        )}
      </div>
    </div>
  )
}

SubmitSection.propTypes = {
  buttonText: PropTypes.string,
  errorMessages: PropTypes.array,
  submitting: PropTypes.bool,
  styleNameButton: PropTypes.string,
  error: PropTypes.string,
  styleNameLoader: PropTypes.string,
  canSubmit: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  gtmEvents: PropTypes.array
}

export default SubmitSection



// WEBPACK FOOTER //
// ./src/components/forms/submit-section.jsx